import { deletionsQuery, privacySettingsQuery } from "@commerce/privacy/meta";
import {
	PrivacySettings,
	PrivacySettingsSkeleton,
} from "@commerce/privacy/PrivacySettings";
import { config } from "@repo/config";
import { AdminOnlyNotice } from "@saas/settings/components/SettingsLayout";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_saas/app/_org/$organizationSlug/settings/privacy-data",
)({
	loader: async ({ context }) => {
		const organizationId = context.organization.id;
		const queryClient = getServerQueryClient();
		if (context.isOrganizationAdmin) {
			await Promise.all([
				queryClient.ensureQueryData(
					privacySettingsQuery(organizationId),
				),
				queryClient.ensureQueryData(deletionsQuery(organizationId)),
			]);
		}
		return {
			organizationId,
			dehydratedState: dehydrateForLoader(queryClient),
		};
	},
	head: () => ({ meta: [{ title: `Shopper data - ${config.appName}` }] }),
	component: PrivacyDataPage,
});

function PrivacyDataPage() {
	const { isOrganizationAdmin } = Route.useRouteContext();
	const { organizationId, dehydratedState } = Route.useLoaderData();

	if (!isOrganizationAdmin) {
		return <AdminOnlyNotice what="privacy and data settings" />;
	}

	return (
		<AsyncBoundary
			fallback={<PrivacySettingsSkeleton />}
			dehydratedState={dehydratedState}
			errorFallback="inline"
		>
			<PrivacySettings organizationId={organizationId} />
		</AsyncBoundary>
	);
}
